/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Subscription_QueryVariables = {
    subscriptionID: string;
};
export type App_Subscription_QueryResponse = {
    readonly subscription: {
        readonly " $fragmentRefs": FragmentRefs<"Subscription_subscription">;
    } | null;
    readonly subscriptionFee: number;
};
export type App_Subscription_Query = {
    readonly response: App_Subscription_QueryResponse;
    readonly variables: App_Subscription_QueryVariables;
};



/*
query App_Subscription_Query(
  $subscriptionID: ID!
) {
  subscription: node(id: $subscriptionID) {
    __typename
    ... on Subscription {
      ...Subscription_subscription
    }
    id
  }
  subscriptionFee
}

fragment CostCalculator_service on Service {
  charges(first: 100) {
    edges {
      node {
        id
        chargeType
        name
        description
        price {
          value
          currency
        }
        metricName
        salesTax {
          value
          currency
        }
      }
    }
  }
}

fragment Subscription_subscription on Subscription {
  id
  service {
    id
    name
    description
    imageURL
    charges(first: 100) {
      edges {
        node {
          id
          chargeType
          name
          description
          price {
            value
            currency
          }
          metricName
          salesTax {
            value
            currency
          }
        }
      }
    }
    ...CostCalculator_service
  }
  secret
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subscriptionID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "subscriptionID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionFee",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "App_Subscription_Query",
    "selections": [
      {
        "alias": "subscription",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Subscription_subscription"
              }
            ],
            "type": "Subscription",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "App_Subscription_Query",
    "selections": [
      {
        "alias": "subscription",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Service",
                "kind": "LinkedField",
                "name": "service",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageURL",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                      }
                    ],
                    "concreteType": "ChargeConnection",
                    "kind": "LinkedField",
                    "name": "charges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChargeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Charge",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "chargeType",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Amount",
                                "kind": "LinkedField",
                                "name": "price",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "metricName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Amount",
                                "kind": "LinkedField",
                                "name": "salesTax",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "charges(first:100)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secret",
                "storageKey": null
              }
            ],
            "type": "Subscription",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "9b0e3fea77500f604e8c2b3490ed478f",
    "id": null,
    "metadata": {},
    "name": "App_Subscription_Query",
    "operationKind": "query",
    "text": "query App_Subscription_Query(\n  $subscriptionID: ID!\n) {\n  subscription: node(id: $subscriptionID) {\n    __typename\n    ... on Subscription {\n      ...Subscription_subscription\n    }\n    id\n  }\n  subscriptionFee\n}\n\nfragment CostCalculator_service on Service {\n  charges(first: 100) {\n    edges {\n      node {\n        id\n        chargeType\n        name\n        description\n        price {\n          value\n          currency\n        }\n        metricName\n        salesTax {\n          value\n          currency\n        }\n      }\n    }\n  }\n}\n\nfragment Subscription_subscription on Subscription {\n  id\n  service {\n    id\n    name\n    description\n    imageURL\n    charges(first: 100) {\n      edges {\n        node {\n          id\n          chargeType\n          name\n          description\n          price {\n            value\n            currency\n          }\n          metricName\n          salesTax {\n            value\n            currency\n          }\n        }\n      }\n    }\n    ...CostCalculator_service\n  }\n  secret\n}\n"
  }
};
})();
(node as any).hash = '9f4f5682c6b5483ae3b53b93f7efd99f';
export default node;
